const VISITOR_ID_COOKIE = 'visitor_id';

function clampPercent(percent: number): number {
  if (percent < 0) return 0;
  if (percent > 100) return 100;
  return percent;
}

function hexDigitToInt(char: string): number {
  switch (char.toLowerCase()) {
    case '0':
      return 0;
    case '1':
      return 1;
    case '2':
      return 2;
    case '3':
      return 3;
    case '4':
      return 4;
    case '5':
      return 5;
    case '6':
      return 6;
    case '7':
      return 7;
    case '8':
      return 8;
    case '9':
      return 9;
    case 'a':
      return 10;
    case 'b':
      return 11;
    case 'c':
      return 12;
    case 'd':
      return 13;
    case 'e':
      return 14;
    case 'f':
      return 15;
    default:
      return -1;
  }
}

function readCookie(name: string): string {
  if (typeof document === 'undefined') return '';
  const cookies = document.cookie;
  if (!cookies) return '';
  const parts = cookies.replace(/ /g, '').split(';');
  for (const part of parts) {
    const eq = part.indexOf('=');
    if (eq === -1) continue;
    const key = part.slice(0, eq);
    if (key === name) {
      return part.slice(eq + 1);
    }
  }
  return '';
}

export function getRolloutedValues(visitorId: string, percent = 10): boolean {
  if (visitorId.length === 0) return false;
  const lastChar = visitorId.charAt(visitorId.length - 1);
  const hexVal = hexDigitToInt(lastChar);
  if (hexVal < 0) return false;
  const bucket = Math.floor((clampPercent(percent) * 16) / 100);
  return hexVal < bucket;
}

export function getIsContainsVisitorId(percent = 10): boolean {
  const id = readCookie(VISITOR_ID_COOKIE);
  return getRolloutedValues(id, percent);
}
